import { useEffect, useState } from 'react';
import { memo } from "react";

// Redux & Action
import { useSelector } from 'react-redux';

// Component
import Grid from '@mui/material/Grid';
import ImageShow from "views/components/ImageShow";
// import BackButton from "views/components/BackButton";

// Style & CSS
import "assets/css/Contact.css";

function Contact({ agent_contact }) {
    const selectTheme = process.env?.REACT_APP_SELECT_THEME;
    const dataSetting = useSelector(state => state.reduxAppDataSetting.result);
    const homeData = useSelector(state => state.reduxHome.result);
    const [dataContact, setDataContact] = useState(null);

    const loadLiveChat = () => {
        if (window?.LiveChatWidget) {
            window.LiveChatWidget.on('ready', onReady);
            window.LiveChatWidget.on('visibility_changed', onVisibilityChanged);
        }
    };

    function onVisibilityChanged(data) {
        let visibility = data.visibility;
        if (visibility === "minimized" || visibility === "hidden") {
            window.LiveChatWidget.call("hide");
        }
    }

    const onReady = () => {
        window.LiveChatWidget.call("maximize");
        window.LiveChatWidget.call('set_customer_name', `${homeData ? homeData?.username : "-"}`);
        window.LiveChatWidget.call("set_session_variables", {
            username: (homeData ? homeData.username : "-"),
            balance: (homeData ? homeData.balance : 0),
            phone: (homeData ? (homeData?.phone === "" ? "-" : homeData?.phone) : "-")
        });
    };

    const callContact = (data) => {
        window.open('tel:' + data.channel_appid, "_parent");
    }

    const gotoContact = (data) => {
        if (data.contact_channel === 0 || data.contact_channel === 3 || data.contact_channel === 4) {
            window.open(data.channel_link, "_blank");
        }
        else if (data.contact_channel === 1) {
            loadLiveChat();
        }
        else {
            callContact(data);
        }
    };

    const renderContactImage = (item) => (
        <div className="center">
            {
                item.contact_channel === 0 ?
                    <ImageShow className="contactMenuListImg" src="/images/contact/contact-line.png" alt="ติดต่อเรา แชทไลน์ OA" />
                    :
                    item.contact_channel === 1 ?
                        <ImageShow className="contactMenuListImg" src="/images/contact/livechat-circle.png" alt="ติดต่อเรา ไลฟ์แชท" />
                        :
                        item.contact_channel === 3 ?
                            <ImageShow className="contactMenuListImg" src="/images/contact/telegram.png" alt="ติดต่อเรา เทเลแกรม" />
                            :
                            item.contact_channel === 4 ?
                                <ImageShow className="contactMenuListImg" src="/images/contact/contact-facebook.png" alt="ติดต่อเรา Facebook" />
                                :
                                <ImageShow className="contactMenuListImg" src="/images/contact/phone-call.png" alt="ติดต่อเรา โทร" />
            }
        </div>
    );

    const renderContactText = (item) => (
        <div className="contactMenuListText center">
            {
                item.contact_channel === 0 ?
                    <div className="contactMenuListFlex">
                        <div>
                            แชทไลน์ OA
                        </div>

                        <div className="contactMenuListSubText">
                            {
                                item?.channel_appid
                            }
                        </div>
                    </div>
                    :
                    item.contact_channel === 1 ?
                        <div className="contactMenuListFlex">
                            <div>
                                ไลฟ์แชท
                            </div>

                            <div className="contactMenuListSubText">
                                {
                                    item?.channel_appid
                                }
                            </div>
                        </div>
                        :
                        item.contact_channel === 3 ?
                            <div className="contactMenuListFlex">
                                <div>
                                    เทเลแกรม
                                </div>

                                <div className="contactMenuListSubText">
                                    {
                                        item?.channel_appid
                                    }
                                </div>
                            </div>
                            :
                            item.contact_channel === 4 ?
                                <div className="contactMenuListFlex">
                                    <div>
                                        Facebook
                                    </div>

                                    <div className="contactMenuListSubText">
                                        {
                                            item?.channel_appid
                                        }
                                    </div>
                                </div>
                                :
                                <div className="contactMenuListFlex">
                                    <div>
                                        โทร
                                    </div>

                                    <div className="contactMenuListSubText">
                                        {
                                            item?.channel_appid
                                        }
                                    </div>
                                </div>
            }
        </div>
    );

    const renderContentThemeA = (item, index) => (
        <Grid item key={index} xs={6} md={4} onClick={() => gotoContact(item)}>
            <div className="contactMenuList positionRelative cursorPointer">
                {
                    renderContactImage(item)
                }

                {
                    renderContactText(item)
                }
            </div>
        </Grid>
    );

    const renderContentThemeB = (item, index) => (
        <Grid item key={index} xs={12} md={12} onClick={() => gotoContact(item)}>
            <div className="contactMenuList themeRadiusAllDefault positionRelative cursorPointer">
                <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                        {
                            renderContactImage(item)
                        }
                    </Grid>
                    <Grid item>
                        {
                            renderContactText(item)
                        }
                    </Grid>
                </Grid>
            </div>
        </Grid>
    );

    const renderContent = (item, index) => {
        if (selectTheme === "themeb") {
            return renderContentThemeB(item, index);
        }

        return renderContentThemeA(item, index);
    };

    useEffect(() => {
        if (agent_contact) {
            setDataContact(agent_contact);
        }

        if (!agent_contact) {
            if (dataSetting?.agent_contact) {
                setDataContact(dataSetting?.agent_contact);
            }
        }
    }, [agent_contact, dataSetting?.agent_contact]);

    return dataContact && (
        <Grid container spacing={selectTheme === "themeb" ? 0 : 2}>
            {
                dataContact.map((item, index) => (
                    renderContent(item, index)
                ))
            }
        </Grid>
    );
}

export default memo(Contact);